export default __webpack_public_path__ + "static/2030-29b294b4ab2844940468298214e3dc73.png";